import { CheckIcon, CopyIcon, ExternalLinkIcon } from 'lucide-react'

import { SplitsLink } from '~/components/Link'
import {
  standardButtonVariants,
  standardIconVariants,
  standardLinkVariants,
} from '~/components/component-library/Copyable/styles'
import { StandardCopyableProps } from '~/components/component-library/Copyable/types'
import { truncate } from '~/components/component-library/Copyable/utils'
import { useCopyValue } from '~/hooks/useCopyValue'

export const StandardCopyable = ({
  value,
  displayValue,
  size = 'base',
  truncateMiddle = false,
  href,
  successMessage,
}: StandardCopyableProps) => {
  const { isCopied, handleCopy } = useCopyValue()
  const display = displayValue ?? truncate(value, truncateMiddle)

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={(event) => {
          event.preventDefault()
          event.stopPropagation()
          handleCopy(value, successMessage ?? 'Copied')
        }}
        aria-label={`Copy ${value}`}
        className={standardButtonVariants({ size })}
      >
        <span>{display}</span>
        {isCopied ? (
          <CheckIcon className={standardIconVariants({ size })} />
        ) : (
          <CopyIcon className={standardIconVariants({ size })} />
        )}
      </button>
      {href && (
        <SplitsLink
          target={href.target}
          path={href.path}
          onClick={(event) => event.stopPropagation()}
          className={standardLinkVariants()}
        >
          <ExternalLinkIcon className={standardIconVariants({ size })} />
        </SplitsLink>
      )}
    </div>
  )
}
